import { Helmet } from 'react-helmet';

import { AdministratorRealStateList } from 'components/templates';

const AdministratorRealStateListPage = () => (
    <>
        <Helmet>
            <title>Imobiliárias - Painel Administrador - Imobiler</title>
        </Helmet>

        <AdministratorRealStateList />
    </>
);

export default AdministratorRealStateListPage;
